import { render, staticRenderFns } from "./SupportStrategyModal.vue?vue&type=template&id=05262f72&scoped=true"
import script from "./SupportStrategyModal.vue?vue&type=script&lang=js"
export * from "./SupportStrategyModal.vue?vue&type=script&lang=js"
import style0 from "./SupportStrategyModal.vue?vue&type=style&index=0&id=05262f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05262f72",
  null
  
)

export default component.exports